
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/codefolio",
      function () {
        return require("private-next-pages/projects/codefolio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/codefolio"])
      });
    }
  